import {Injectable} from '@angular/core';
import {ResponsiveService} from './responsive.service';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  rules: any;
  private _showRuleErrorForNotNull: boolean;
  private _showRuleErrorOutsideIconMobile: boolean;
  private _showRuleErrorOutsideIconTablet: boolean;
  private _showRuleErrorOutsideIconDesktop: boolean;

  constructor(
    private responsiveService: ResponsiveService
  ) {
  }

  getRules(): any {
    return this.rules;
  }

  setRules(rules: any): void {
    this.rules = rules;
  }

  getShowRuleErrorForNotNull(): boolean {
    return this._showRuleErrorForNotNull;
  }

  setShowRuleErrorForNotNull(val: boolean): void {
    this._showRuleErrorForNotNull = val;
  }

  getShowRuleErrorOutsideIcon(): boolean {
    if (this.responsiveService.isMobile()) {
      return this._showRuleErrorOutsideIconMobile;
    } else if (this.responsiveService.isTablet()) {
      return this._showRuleErrorOutsideIconTablet;
    } else {
      return this._showRuleErrorOutsideIconDesktop;
    }
  }

  setShowRuleErrorOutsideIconMobile(val: boolean): void {
    this._showRuleErrorOutsideIconMobile = val;
  }

  setShowRuleErrorOutsideIconTablet(val: boolean): void {
    this._showRuleErrorOutsideIconTablet = val;
  }

  setShowRuleErrorOutsideIconDesktop(val: boolean): void {
    this._showRuleErrorOutsideIconDesktop = val;
  }
}
